import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kundesla-list-view',
  imports: [],
  templateUrl: './kundesla.list-view.html',
  styleUrls: ['./kundesla.list-view.css'],
})
export class KundeslaListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
